import { BaseRequests } from "../../../config/BaseRequests";
import { hostersApiEndpoints } from "../api/hosters.api";
import {
  ProAccountDetails,
  UpdateProAccountDto,
  UserDto,
} from "../dto/index.dto";
import { PaginatedResponse } from "../../../shared/dto/pagination.dto";

export class HostersService {
  static getHosters = (
    event: string,
    page: number,
    limit: number
  ): Promise<PaginatedResponse<UserDto>> =>
    BaseRequests.get(hostersApiEndpoints.getHosters(event, page, limit));

  static getHosterById = (
    id: string,
    event: string
  ): Promise<ProAccountDetails> =>
    BaseRequests.get(hostersApiEndpoints.getHosterById(id, event));

  static updateHoster = (
    id: string,
    event: string,
    data: UpdateProAccountDto
  ): Promise<ProAccountDetails> =>
    BaseRequests.patch(hostersApiEndpoints.updateHoster(id, event), data);

  static suspendHoster = (
    id: string,
    event: string
  ): Promise<ProAccountDetails> =>
    BaseRequests.patch(hostersApiEndpoints.suspendHoster(id, event));

  static reactivateHoster = (
    id: string,
    event: string
  ): Promise<ProAccountDetails> =>
    BaseRequests.patch(hostersApiEndpoints.reactivateHoster(id, event));
}
